import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { getOfferForm } from '../selectors'
import OfferRequested from '../components/offerRequested'

const mapStateToProps = state => ({
  form: getOfferForm(state),
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    null,
  ),
)(OfferRequested)



// WEBPACK FOOTER //
// ./src/modules/offer/containers/offerRequested.js